import React from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import StoreUtils from "../../../../../../services/Store/StoreUtils";
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../../../../reducers";
import {getStoreConfig} from "../../../../../../services/Store/reducer";

interface OwnProps {
    quantityInfo: {
        maxPermitted?: number;
        minPermitted?: number;
        chargeAbove?: number;
    };
    quantity: number;
    hideBadge?: true;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const ProductModifierGroupQuantityInfo = ({quantityInfo, quantity, hideBadge, config}: Props) => {
    const {t} = useTranslation();
    const readonly = StoreUtils.isOrderingReadonly(config);

    const getQuantityInfo = () => {
        if (quantityInfo.minPermitted && quantityInfo.maxPermitted && quantityInfo.maxPermitted === quantityInfo.minPermitted && quantityInfo.chargeAbove) {
            if (readonly) {
                return t("modules.menu.field.quantity_rule_exact_with_free_readonly.title", {
                    count: quantityInfo.minPermitted,
                    free: quantityInfo.chargeAbove
                });
            }

            return t("modules.menu.field.quantity_rule_exact_with_free.title", {
                count: quantityInfo.minPermitted,
                free: quantityInfo.chargeAbove
            });
        }
        if (quantityInfo.minPermitted && quantityInfo.maxPermitted && quantityInfo.chargeAbove) {
            if (readonly) {
                return t("modules.menu.field.quantity_rule_range_with_free_readonly.title", {
                    min: quantityInfo.minPermitted,
                    max: quantityInfo.maxPermitted,
                    free: quantityInfo.chargeAbove
                });
            }

            return t("modules.menu.field.quantity_rule_range_with_free.title", {
                min: quantityInfo.minPermitted,
                max: quantityInfo.maxPermitted,
                free: quantityInfo.chargeAbove
            });
        }
        if (!quantityInfo.minPermitted && quantityInfo.maxPermitted && quantityInfo.chargeAbove) {
            if (readonly) {
                return t("modules.menu.field.quantity_rule_max_with_free_readonly.title", {
                    max: quantityInfo.maxPermitted,
                    free: quantityInfo.chargeAbove
                });
            }

            return t("modules.menu.field.quantity_rule_max_with_free.title", {
                max: quantityInfo.maxPermitted,
                free: quantityInfo.chargeAbove
            });
        }
        if (!quantityInfo.maxPermitted && quantityInfo.minPermitted && quantityInfo.chargeAbove) {
            if (readonly) {
                return t("modules.menu.field.quantity_rule_min_with_free_readonly.title", {
                    min: quantityInfo.minPermitted,
                    free: quantityInfo.chargeAbove
                });
            }

            return t("modules.menu.field.quantity_rule_min_with_free.title", {
                min: quantityInfo.minPermitted,
                free: quantityInfo.chargeAbove
            });
        }
        if (quantityInfo.maxPermitted && quantityInfo.minPermitted && quantityInfo.maxPermitted === quantityInfo.minPermitted && !quantityInfo.chargeAbove) {
            if (readonly) {
                return t("modules.menu.field.quantity_rule_exact_readonly.title", {
                    count: quantityInfo.minPermitted,
                    free: quantityInfo.chargeAbove
                });
            }

            return t("modules.menu.field.quantity_rule_exact.title", {
                count: quantityInfo.minPermitted,
                free: quantityInfo.chargeAbove
            });
        }
        if (quantityInfo.minPermitted && quantityInfo.maxPermitted) {
            if (readonly) {
                return t("modules.menu.field.quantity_rule_range_readonly.title", {
                    min: quantityInfo.minPermitted,
                    max: quantityInfo.maxPermitted,
                });
            }

            return t("modules.menu.field.quantity_rule_range.title", {
                min: quantityInfo.minPermitted,
                max: quantityInfo.maxPermitted,
            });
        }
        if (quantityInfo.minPermitted && !quantityInfo.maxPermitted) {
            if (readonly) {
                return t("modules.menu.field.quantity_rule_min_readonly.title", {
                    count: quantityInfo.minPermitted
                });
            }

            return t("modules.menu.field.quantity_rule_min.title", {
                count: quantityInfo.minPermitted
            });
        }
        if (!quantityInfo.minPermitted && quantityInfo.maxPermitted) {
            if (readonly) {
                return t("modules.menu.field.quantity_rule_max_readonly.title", {
                    count: quantityInfo.maxPermitted
                });
            }

            return t("modules.menu.field.quantity_rule_max.title", {
                count: quantityInfo.maxPermitted
            });
        }
    };

    const getBadgeColor = () => {
        if (quantityInfo.minPermitted && quantityInfo.minPermitted > quantity) return "danger-light";

        return "success-light";
    }

    return (
        <div className="product-modifier-group-quantity-info d-flex align-items-start gap-2 justify-content-between">
            {!!(quantityInfo.minPermitted || quantityInfo.maxPermitted || quantityInfo.chargeAbove) && (
                <p className="text-muted mb-0 fw-normal">{getQuantityInfo()}</p>
            )}
            {!hideBadge && !readonly && (
                <span className={`badge badge-${getBadgeColor()} ms-auto`}>
                    {`${t("modules.menu.field.default_quantity.title")}: ${quantity}`}
                </span>
            )}
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(ProductModifierGroupQuantityInfo));
